import { merge } from "lodash-es"
import {
  EXTERNAL_TRANSACTION_DESER,
  ExternalTransaction,
  RECURRING_DEPOSIT_DESER,
  RecurringDeposit,
} from "../../tastyworks/cash-management/index"
import type HttpClient from "../../tastyworks/http"
import type { PaginationParams } from "../../tastyworks/request"
import {
  updateSingleResponse,
  type ItemsResponse,
  type SingleResponse,
} from "../../tastyworks/response"

export class RecurringDepositService {
  constructor(private readonly accountNumberClient: HttpClient) {}

  readonly index = async (
    accountNumber: string,
    params?: PaginationParams
  ): Promise<ItemsResponse<RecurringDeposit>> =>
    this.accountNumberClient.indexSimple(
      RECURRING_DEPOSIT_DESER.toParser(RecurringDeposit),
      "recurring-deposits",
      merge({ accountNumber }, params)
    )

  readonly destroy = async (
    recurringDeposit: RecurringDeposit
  ): Promise<SingleResponse<RecurringDeposit>> => {
    const helper = await this.accountNumberClient.doDelete(
      "recurring-deposits/:recurringDepositId",
      {
        accountNumber: recurringDeposit.accountNumber,
        recurringDepositId: recurringDeposit.id,
      }
    )

    return updateSingleResponse(
      helper,
      recurringDeposit,
      RECURRING_DEPOSIT_DESER.update
    )
  }

  readonly indexDeposits = async (
    recurringDeposit: RecurringDeposit,
    params?: PaginationParams
  ): Promise<ItemsResponse<ExternalTransaction>> =>
    this.accountNumberClient.indexSimple(
      EXTERNAL_TRANSACTION_DESER.toParser(ExternalTransaction),
      "recurring-deposits/:recurringDepositId/deposits",
      merge(
        {
          accountNumber: recurringDeposit.accountNumber,
          recurringDepositId: recurringDeposit.id,
        },
        params
      )
    )

  readonly create = async (
    recurringDeposit: RecurringDeposit
  ): Promise<SingleResponse<RecurringDeposit>> =>
    this.accountNumberClient.create(
      recurringDeposit,
      RECURRING_DEPOSIT_DESER.serialize,
      RECURRING_DEPOSIT_DESER.update,
      "recurring-deposits",
      { accountNumber: recurringDeposit.accountNumber }
    )
}
